<sew-table-header-filter
    #sewTableHeaderFilter
    [label]="name"
    [sortOrder]="sortOrderObs | async"
    [sortDefault]="'SORT_ORDER.DEFAULT' | translate: { label: name }"
    [sortDescending]="'SORT_ORDER.DESCENDING' | translate: { label: name }"
    [sortAscending]="'SORT_ORDER.ASCENDING' | translate: { label: name }"
    [ellipsis]="ellipsis"
    [hasReset]="hasReset"
    [hideSortIconOnClosedState]="hideSortIconOnClosedState"
    (sort)="updateSorting($any($event).detail)"
>
    <!-- filterValue | async is not beeing used as an input, just as a subscribe to trigger the pipe transformations -->
    <select #select [ngModel]="filterValue | async" (change)="updateFilter(select.value, filterType)">
        @for (option of filterValues; track option) {
            <option [value]="option.value">{{ option.key }}</option>
        }
    </select>
</sew-table-header-filter>
